export default __webpack_public_path__ + "static/media/image.curve-up-pvt-ltd.514eab64.png";